module.exports = __webpack_public_path__ + "static/media/ppe_rad_con_ala.a8a5f7bc.png";